import {DashboardStore} from "store/dashboard/DashboardStore"
import {makeAutoObservable} from "mobx"

export class ImpactHistoryStore {
    private dashboardStore: DashboardStore;
    page: number = 0
    pageSize: number = 10
    location?: { lat: number, lng: number }

    constructor(dashboardStore: DashboardStore) {
        this.dashboardStore = dashboardStore
        makeAutoObservable(this)
    }

    setPage = (page: number) => {
        this.page = page
    }

    setLocation = (location?: {
        lat: number,
        lng: number
    }) => {
        this.location = location
    }

}